import { useEffect, useState } from 'react';

import Button from '../components/Common/Button';
import { useLazyFetchAllUserAuditDetailsQuery } from '../services/userAudits/userAuditsApi';

const UserAudits = () => {
  const availableDashboards = [
    { id: 9001, name: 'Company Tests' },
    { id: 9002, name: 'Tech Interview' },
    { id: 9003, name: 'HR Interview' },
    { id: 9004, name: 'Code Sense AI' },
    { id: 9006, name: 'Schedule Test' },
    { id: 9007, name: 'Custom Written Test' },
    { id: 9008, name: 'Drive Test' },
    { id: 9009, name: 'Cloud Prep' }
  ];

  const [getUseersAudits, { isLoading, isFetching }] =
    useLazyFetchAllUserAuditDetailsQuery({});
  const [userAuditData, setuserAuditData] = useState([]);
  const [lastUpdate, setLastUpdate] = useState('');

  const refetchData = async () => {
    try {
      const result = await getUseersAudits({});
      if (result?.isSuccess) {
        setuserAuditData(result?.data?.data || []);
        const formatted = result?.data?.recentUpdation
          ?.split('.')[0]
          .replace('T', ' ');
        setLastUpdate(formatted || '');
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    refetchData();
  }, []);

  return (
    <div className='p-8'>
      <div className='mb-3 flex justify-between'>
        <div>
          <p className='text-lg font-medium'>
            Total Users: {userAuditData?.length}
          </p>
          <p className='text-lg font-medium'>Last Updated: {lastUpdate}</p>
        </div>
        <Button
          variant='outlined'
          disabled={isLoading || isFetching}
          label='Refetch'
          handleClickBtn={refetchData}
        />
      </div>
      <div className='overflow-x-auto md:w-[calc(100vw-320px)]'>
        <table className='min-w-full overflow-x-auto rounded-lg border border-gray-300 bg-white shadow-md'>
          <thead className='bg-primary text-white'>
            <tr>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                Email ID
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                Moile Number
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                User Name
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                Dashboards
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                Company Testss
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                Programming Test
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                Interview
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                HR Interview
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                College
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                Year Of Passing
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                Location
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                Pro Expire Date
              </th>
              <th className='px-6 py-3 text-left text-sm font-medium uppercase tracking-wider'>
                Pro Validity Days
              </th>
            </tr>
          </thead>
          <tbody className='divide-y divide-gray-200'>
            {userAuditData?.map((each: any, index: number) => (
              <tr
                key={each?.userId}
                className={`transition-colors duration-200 hover:bg-slate-50 ${
                  index % 2 === 0 ? 'bg-white' : 'bg-slate-50'
                }`}
              >
                <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
                  {each?.emailId}
                </td>
                <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
                  {each?.mobileNumber}
                </td>
                <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
                  {each?.userName}
                </td>
                <td className='gap-2 overflow-y-scroll'>
                  <div className='max-w-sm text-sm text-gray-900'>
                    {each?.dashboards && each.dashboards.length > 0 ? (
                      <div className='flex w-[220px] flex-wrap gap-1 py-3'>
                        {each.dashboards.map((dashId: any) => {
                          const dashboard = availableDashboards.find(
                            d => d.id === dashId
                          );
                          return (
                            <span
                              key={dashId}
                              className='inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700'
                            >
                              {dashboard?.name || '-'}
                            </span>
                          );
                        })}
                      </div>
                    ) : (
                      <span className='text-xs text-gray-400'>
                        No dashboards
                      </span>
                    )}
                  </div>
                </td>
                <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
                  {each?.writtenTestsAttempts}
                </td>
                <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
                  {each?.programmingTestAttempts ?? '-'}
                </td>
                <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
                  {each?.interviewAttempts}
                </td>
                <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
                  {each?.hrInterviewAttempts}
                </td>
                <td className='whitespace-pre-wrap px-6 py-4 text-sm text-gray-900'>
                  {each?.college ?? '-'}
                </td>
                <td className='whitespace-pre-wrap px-6 py-4 text-sm text-gray-900'>
                  {each?.yearOfPassing ?? '-'}
                </td>
                <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
                  {each?.location ?? '-'}
                </td>
                <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
                  {each?.proTillDate?.split('T')[0] ?? '-'}
                </td>
                <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
                  {each?.proValidityDays ?? '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {userAuditData?.length === 0 && (
        <div className='py-8 text-center text-gray-500'>
          No user audit data available
        </div>
      )}
    </div>
  );
};

export default UserAudits;
